<div [id]="id" class="chart-viewport" inViewport (inViewportAction)="loadChart($event)"
  [style]="{ height: pieSize, width: pieSize }"></div>
